/**
 * Royal Chou — Workshop Landing Page
 * File: assets/workshop-landing.js
 *
 * Add to theme.liquid before </body>:
 * {{ 'workshop-landing.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  function init() {
    try { initHeroImage(); } catch (e) { console.warn('WL HeroImg:', e); }
    try { initForm(); }    catch (e) { console.warn('WL Form:', e); }
    try { initReveal(); }  catch (e) { console.warn('WL Reveal:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 50);
  }

  /* ══════════════════════════════════════
     HERO IMAGE SWAP
     Single <img> tag. Swaps src between
     desktop and mobile on load and resize.
     Below 768px = mobile src.
     768px and above = desktop src.
  ══════════════════════════════════════ */
  function initHeroImage() {
    var img = document.getElementById('wl-hero-img');
    if (!img) return;

    var srcDesktop = img.getAttribute('data-src-desktop');
    var srcMobile  = img.getAttribute('data-src-mobile');
    if (!srcDesktop && !srcMobile) return;

    function setImage() {
      var isMobile = window.innerWidth < 768;
      var newSrc = isMobile ? srcMobile : srcDesktop;
      if (newSrc && img.src !== newSrc) img.src = newSrc;
    }

    // Set on load
    setImage();

    // Update on resize (debounced)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setImage, 150);
    });
  }

  /* ══════════════════════════════════════
     FORM — VALIDATION + FORMSPREE SUBMIT
     ══════════════════════════════════════
     Fields validated:
     - First name     → required
     - Last name      → required
     - Email          → required + format
     - Preferred time → required (select)
     - Experience     → required (radio)
     - Note           → optional

     On success: form section hides,
     thank-you section reveals.
  */
  function initForm() {
    var form = document.getElementById('wl-form');
    if (!form) return;

    /* Live clear on fix */
    var emailEl = document.getElementById('wl-email');
    if (emailEl) {
      emailEl.addEventListener('input', function () {
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.value.trim())) hideErr('wl-email-err');
      });
    }
    var fnameEl = document.getElementById('wl-fname');
    if (fnameEl) fnameEl.addEventListener('input', function () { if (this.value.trim()) hideErr('wl-fname-err'); });
    var lnameEl = document.getElementById('wl-lname');
    if (lnameEl) lnameEl.addEventListener('input', function () { if (this.value.trim()) hideErr('wl-lname-err'); });
    var timeEl = document.getElementById('wl-time');
    if (timeEl) timeEl.addEventListener('change', function () { if (this.value) hideErr('wl-time-err'); });
    form.querySelectorAll('input[name="experience"]').forEach(function (r) {
      r.addEventListener('change', function () { hideErr('wl-exp-err'); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate(form)) {
        var first = form.querySelector('.wl-error.visible');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var btn = document.getElementById('wl-submit');
      if (btn) { btn.textContent = 'Sending...'; btn.disabled = true; }

      var exp = form.querySelector('input[name="experience"]:checked');
      var data = {
        first_name:     val('wl-fname'),
        last_name:      val('wl-lname'),
        email:          val('wl-email'),
        preferred_time: document.getElementById('wl-time') ? document.getElementById('wl-time').value : '',
        experience:     exp ? exp.value : '',
        note:           val('wl-note'),
        _subject:       'Royal Chou Workshop — New Registration'
      };

      /* Get Formspree ID from data attribute on root element */
      var page = document.getElementById('wl-page');
      var formspreeId = page ? page.getAttribute('data-formspree') : '';

      if (!formspreeId || formspreeId === 'YOUR_FORMSPREE_ID') {
        /* Dev mode: no Formspree ID set yet — still show thank you */
        console.warn('WL: No Formspree ID configured. Add it in theme editor settings.');
        showThankyou();
        return;
      }

      fetch('https://formspree.io/f/' + formspreeId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function (res) {
        if (!res.ok) console.error('WL: Formspree error', res.status);
        showThankyou();
      })
      .catch(function (err) {
        console.error('WL: Submission error', err);
        showThankyou(); /* Always show thank you — never block customer */
      });
    });
  }

  function validate(form) {
    var ok = true;

    /* First name */
    var fname = val('wl-fname');
    if (!fname) { showErr('wl-fname-err', 'Please enter your first name.'); ok = false; }
    else hideErr('wl-fname-err');

    /* Last name */
    var lname = val('wl-lname');
    if (!lname) { showErr('wl-lname-err', 'Please enter your last name.'); ok = false; }
    else hideErr('wl-lname-err');

    /* Email */
    var email = val('wl-email');
    if (!email) { showErr('wl-email-err', 'Please enter your email address.'); ok = false; }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showErr('wl-email-err', 'Please enter a valid email address.'); ok = false; }
    else hideErr('wl-email-err');

    /* Preferred time */
    var timeEl = document.getElementById('wl-time');
    if (!timeEl || !timeEl.value) { showErr('wl-time-err', 'Please select a preferred time.'); ok = false; }
    else hideErr('wl-time-err');

    /* Experience */
    var exp = form.querySelector('input[name="experience"]:checked');
    if (!exp) { showErr('wl-exp-err', 'Please let us know your embroidery experience.'); ok = false; }
    else hideErr('wl-exp-err');

    return ok;
  }

  function showThankyou() {
    var formSection = document.getElementById('wl-form-section');
    if (formSection) formSection.style.display = 'none';
    var thanks = document.getElementById('wl-thankyou');
    if (!thanks) return;
    thanks.classList.remove('wl-hidden');
    setTimeout(function () { thanks.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80);
  }

  /* ══════════════════════════════════════
     SCROLL REVEAL
  ══════════════════════════════════════ */
  function initReveal() {
    var targets = document.querySelectorAll(
      '.wl-expect-item, .wl-about-inner, .wl-audience, .wl-form-header, .wl-field'
    );
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    targets.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.65s ease ' + (i * 0.06) + 's, transform 0.65s ease ' + (i * 0.06) + 's';
      io.observe(el);
    });
  }

  /* HELPERS */
  function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  function showErr(id, msg) { var el = document.getElementById(id); if (!el) return; el.textContent = msg; el.classList.add('visible'); }
  function hideErr(id) { var el = document.getElementById(id); if (el) el.classList.remove('visible'); }

})();